import { render, staticRenderFns } from "./VistaPreviaComponent.vue?vue&type=template&id=6a9ed2de&scoped=true"
import script from "./VistaPreviaComponent.vue?vue&type=script&lang=js"
export * from "./VistaPreviaComponent.vue?vue&type=script&lang=js"
import style0 from "./VistaPreviaComponent.vue?vue&type=style&index=0&id=6a9ed2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ed2de",
  null
  
)

export default component.exports